{
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "errors": {
    "WAREHOUSE_ARCHIVED": "لا يمكن استخدام مستودع مؤرشف. اختر مستودعًا نشطًا.",
    "WAREHOUSE_MAIN": "هذا هو المستودع الرئيسي. اجعل مستودعًا آخر رئيسيًا أولًا.",
    "WAREHOUSE_NOT_EMPTY": "ما زال في هذا المستودع مخزون. انقل المخزون المتبقي أو سوِّه أولًا.",
    "WAREHOUSE_IN_USE": "تبيع صناديق نقطة البيع من هذا المستودع ({{tills}}). اختر لها مستودعًا آخر من نقاط البيع › الصناديق أولًا.",
    "NO_MAIN_WAREHOUSE": "لا يوجد مستودع رئيسي. حدّد واحدًا من صفحة المستودعات أولًا.",
    "COST_REQUIRED": "المخزون المضاف يحتاج إلى تكلفة للوحدة. أدخلها في كل بند يضيف مخزونًا.",
    "INVALID_COST": "لا يمكن أن تكون التكلفة سالبة. راجع التكاليف في البنود.",
    "WHOLE_UNITS_ONLY": "أحد المنتجات في هذه التسوية يُعدّ بوحدات كاملة. احذف الكسور.",
    "INVALID_MOVEMENT": "أحد البنود لا يغيّر المخزون. احذفه أو أدخل كمية.",
    "STOCK_ALREADY_USED": "بيع جزء من المخزون الذي أضافته هذه التسوية أو استُخدم. سجّل تسوية جديدة بدلًا من الإبطال.",
    "SERIAL_COUNT_MISMATCH": "البند الذي يتتبّع الأرقام التسلسلية يحتاج إلى رقم تسلسلي لكل وحدة. راجع الأرقام التسلسلية في البنود.",
    "SERIAL_NOT_AVAILABLE": "بعض الأرقام التسلسلية غير متاحة هنا: {{serials}}. اخترها من جديد.",
    "SERIAL_DUPLICATE": "بعض الأرقام التسلسلية مكررة، أو موجودة في المخزون أو مبيعة بالفعل: {{serials}}.",
    "SERIALS_NOT_TRACKED": "أحد المنتجات في هذا المستند لا يتتبّع الأرقام التسلسلية. احذف أرقامه التسلسلية.",
    "SERIAL_MOVED_ON": "تحرّك بعض أرقامه التسلسلية منذ ذلك الحين (بيعت أو حُوّلت أو أُزيلت)، لذا لا يمكن إبطاله: {{serials}}."
  },
  "reason": {
    "OPENING": "مخزون افتتاحي",
    "PURCHASE": "شراء",
    "PURCHASE_RETURN": "مرتجع إلى مورد",
    "SALE": "بيع",
    "SALE_RETURN": "مرتجع من عميل",
    "TRANSFER_OUT": "تحويل صادر",
    "TRANSFER_IN": "تحويل وارد",
    "ADJUSTMENT": "تسوية",
    "PROJECT_ISSUE": "صرف إلى مشروع",
    "PROJECT_RETURN": "مرتجع من مشروع"
  },
  "source": {
    "StockAdjustment": "تسوية مخزون",
    "SalesInvoice": "فاتورة مبيعات",
    "CreditNote": "إشعار دائن",
    "Purchase": "مشتريات",
    "SupplierReturn": "مرتجع إلى مورد",
    "ProjectMaterialIssue": "صرف مواد",
    "StockTransfer": "تحويل مخزون"
  },
  "warehouses": {
    "title": "المستودعات",
    "subtitle": "أماكن حفظ المخزون. يُستخدم المستودع الرئيسي حين لا يحدد المستند مستودعًا.",
    "new": "مستودع جديد",
    "newTitle": "مستودع جديد",
    "newSubtitle": "يصبح أول مستودع هو المستودع الرئيسي.",
    "editTitle": "تعديل المستودع",
    "save": "حفظ المستودع",
    "actions": "إجراءات",
    "showArchived": "إظهار المؤرشفة",
    "empty": "لا توجد مستودعات بعد.",
    "emptyBody": "أضف المخزن أو المحل الذي تحفظ فيه بضاعتك.",
    "main": "رئيسي",
    "archived": "مؤرشف",
    "stock": "المخزون",
    "stockOf": "المخزون في {{name}}",
    "editNamed": "تعديل {{name}}",
    "moreNamed": "إجراءات أخرى لـ {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "setMain": "جعله المستودع الرئيسي",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "status": "الحالة"
    },
    "hints": {
      "code": "رمز قصير يظهر في حركات المخزون، مثل MAIN أو SHOP-2."
    },
    "mainDialog": {
      "title": "جعل {{name}} المستودع الرئيسي؟",
      "body": "المستندات التي لا تحدد مستودعًا ستأخذ المخزون منه."
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يستقبل مخزونًا أو يصرفه بعد الآن. لا يُؤرشف إلا مستودع فارغ ليس هو الرئيسي.",
      "confirm": "أرشفة"
    },
    "restore": {
      "title": "استعادة {{name}}؟",
      "body": "سيستقبل المخزون ويصرفه مرة أخرى.",
      "confirm": "استعادة"
    },
    "errors": {
      "codeTaken": "يوجد مستودع آخر بهذا الرمز.",
      "version": "عدّل شخص آخر هذا المستودع. أغلق هذه اللوحة وافتحها مرة أخرى."
    },
    "toast": {
      "created": "أُضيف المستودع",
      "updated": "حُفظ المستودع",
      "archived": "أُرشف المستودع",
      "restored": "استُعيد المستودع",
      "main": "أصبح {{name}} المستودع الرئيسي"
    },
    "movements": "حركات المخزون",
    "figures": {
      "value": "القيمة",
      "items": "الأصناف المتوفرة",
      "low": "لإعادة الطلب"
    }
  },
  "stock": {
    "title": "أرصدة المخزون",
    "subtitle": "الكميات المتوفرة بمتوسط التكلفة المرجّح، في مستودع واحد أو في كل المستودعات.",
    "adjust": "تسوية المخزون",
    "searchPlaceholder": "ابحث بالاسم أو رمز الصنف أو الباركود…",
    "searchLabel": "البحث في المخزون",
    "clearSearch": "مسح البحث",
    "warehouseFilter": "المستودع",
    "allWarehouses": "كل المستودعات",
    "belowReorder": "عند حد إعادة الطلب أو دونه",
    "low": "عند حد إعادة الطلب أو دونه",
    "rowHint": "افتح صفًا لعرض حركات مخزونه.",
    "pageValue": "القيمة في هذه الصفحة",
    "clearFilters": "مسح عوامل التصفية",
    "fields": {
      "product": "المنتج",
      "sku": "رمز الصنف",
      "onHand": "المتوفر",
      "reorderLevel": "حد إعادة الطلب",
      "averageCost": "متوسط التكلفة",
      "value": "القيمة"
    },
    "empty": {
      "title": "لا توجد منتجات مخزّنة بعد.",
      "body": "تظهر البضائع هنا بعد إضافتها كمنتجات.",
      "filteredTitle": "لا توجد نتائج مطابقة.",
      "filteredBody": "جرّب بحثًا آخر، أو اعرض كل المنتجات."
    },
    "rowActions": "إجراءات {{name}}",
    "actions": {
      "movements": "الحركات",
      "adjust": "تسوية المخزون",
      "count": "جرد المخزون",
      "transfer": "تحويل",
      "product": "فتح المنتج"
    },
    "stats": {
      "label": "أرقام المخزون",
      "items": "الأصناف",
      "itemsDetail": "المنتجات والمتغيرات في القائمة",
      "low": "عند حد إعادة الطلب أو دونه",
      "lowDetail": "حان وقت إعادة الطلب",
      "lowShare": "{{percent}}٪ من الأصناف عند حد إعادة الطلب أو دونه",
      "out": "نفد المخزون",
      "outDetail": "منتجات بلا كمية متوفرة",
      "value": "القيمة بالتكلفة",
      "valueDetail_zero": "لا أصناف",
      "valueDetail_one": "صنف واحد بمتوسط التكلفة المرجّح",
      "valueDetail_two": "صنفان بمتوسط التكلفة المرجّح",
      "valueDetail_few": "{{n}} أصناف بمتوسط التكلفة المرجّح",
      "valueDetail_many": "{{n}} صنفًا بمتوسط التكلفة المرجّح",
      "valueDetail_other": "{{n}} صنف بمتوسط التكلفة المرجّح",
      "unavailable": "الأرقام غير متاحة"
    }
  },
  "movements": {
    "title": "حركات المخزون",
    "subtitle": "كل استلام أو صرف للمخزون، الأحدث أولًا.",
    "productFilter": "المنتج",
    "allProducts": "كل المنتجات",
    "selectedProduct": "المنتج المحدد",
    "clearProduct": "عرض كل المنتجات",
    "warehouseFilter": "المستودع",
    "allWarehouses": "كل المستودعات",
    "balanceHint": "اختر منتجًا ومستودعًا لعرض الرصيد بعد كل حركة.",
    "clearFilters": "مسح عوامل التصفية",
    "fields": {
      "date": "التاريخ",
      "warehouse": "المستودع",
      "product": "المنتج",
      "reason": "السبب",
      "quantity": "الكمية",
      "unitCost": "تكلفة الوحدة",
      "value": "القيمة",
      "balanceAfter": "الرصيد بعد الحركة",
      "source": "المصدر",
      "createdBy": "بواسطة"
    },
    "empty": {
      "title": "لا توجد حركات مخزون بعد.",
      "body": "يظهر هنا المخزون الافتتاحي والمشتريات والمبيعات والتسويات.",
      "filteredTitle": "لا توجد حركات مطابقة.",
      "filteredBody": "جرّب منتجًا أو مستودعًا أو فترة أخرى، أو امسح عوامل التصفية."
    },
    "system": "النظام",
    "reasonFilter": "نوع الحركة",
    "allReasons": "كل الأنواع",
    "productChip": "المنتج: {{name}}"
  },
  "adjustments": {
    "newTitle": "تسوية مخزون جديدة",
    "newSubtitle": "تُرحَّل إلى المخزون ودفتر الأستاذ فورًا. يُحدَّد الرقم عند الترحيل.",
    "prefillFailed": "تعذّر تحميل المنتج. اختره في السطر بدلًا من ذلك.",
    "post": "ترحيل التسوية",
    "saveHint": "اضغط {{shortcut}} للترحيل",
    "movements": "حركات المخزون",
    "status": {
      "POSTED": "مرحّلة",
      "VOID": "مُبطَلة"
    },
    "kind": {
      "OPENING": "مخزون افتتاحي",
      "ADJUSTMENT": "تسوية",
      "COUNT": "جرد"
    },
    "kindHint": {
      "OPENING": "المخزون الموجود لديك عند البدء، يُستلم بتكلفته.",
      "ADJUSTMENT": "إضافة كميات أو خصمها: تلف أو فقد أو مخزون عُثر عليه. الزيادات تحتاج إلى تكلفة.",
      "COUNT": "أدخل ما عددته؛ ويُطبَّق الفرق عن المتوفر."
    },
    "linesHint": {
      "OPENING": "أدخل الكمية المتوفرة وتكلفة الوحدة لكل منتج.",
      "ADJUSTMENT": "أدخل التغيير: 5 تضيف خمسة، و‎-2 تخصم اثنين. يُصرف المخزون المخصوم بمتوسط تكلفته.",
      "COUNT": "أدخل الكمية المعدودة. تُقيَّم الزيادة بالتكلفة التي تدخلها، أو بمتوسط التكلفة."
    },
    "quantityHeader": {
      "OPENING": "الكمية",
      "ADJUSTMENT": "التغيير",
      "COUNT": "المعدود"
    },
    "sections": {
      "adjustment": "التسوية",
      "lines": "المنتجات"
    },
    "fields": {
      "date": "التاريخ",
      "warehouse": "المستودع",
      "kind": "النوع",
      "notes": "ملاحظات",
      "product": "المنتج",
      "unitCost": "تكلفة الوحدة",
      "value": "القيمة",
      "delta": "التغيير",
      "totalValue": "إجمالي القيمة",
      "createdAt": "تاريخ التسجيل",
      "number": "الرقم",
      "status": "الحالة",
      "reason": "السبب",
      "createdBy": "سجّلها",
      "systemQuantity": "المتوفر",
      "difference": "الفرق",
      "journalEntry": "القيد اليومي"
    },
    "chooseWarehouse": "اختر مستودعًا",
    "chooseProduct": "اختر منتجًا",
    "addLine": "إضافة منتج",
    "removeLine": "حذف البند {{n}}",
    "lineActions": "إجراءات البند",
    "enterHint": "الضغط على Enter في آخر بند يضيف بندًا جديدًا.",
    "totalKnown": "قيمة المخزون المضاف",
    "productOfLine": "المنتج في البند {{n}}",
    "quantityOfLine": "الكمية في البند {{n}}",
    "costOfLine": "تكلفة الوحدة في البند {{n}}",
    "atAverage": "بمتوسط التكلفة",
    "optional": "اختياري",
    "valuedOnPosting": "تُحدَّد عند الترحيل",
    "voidTitle": "هذه التسوية مُبطَلة",
    "voidReason": "السبب: {{reason}}",
    "void": {
      "action": "إبطال",
      "title": "إبطال {{number}}؟",
      "body": "تُعكس حركات المخزون الخاصة بها ويُعكس قيدها في التاريخ نفسه.",
      "reason": "السبب",
      "confirm": "إبطال التسوية"
    },
    "lineErrors": {
      "chooseWarehouse": "اختر مستودعًا",
      "chooseProduct": "اختر منتجًا",
      "duplicateProduct": "هذا المنتج موجود في بند آخر",
      "quantityRequired": "أدخل الكمية",
      "openingPositive": "يجب أن تكون الكميات الافتتاحية أكبر من صفر",
      "changeNonZero": "أدخل مقدار التغيير في الكمية (لا يكون صفرًا)",
      "countNotNegative": "لا يمكن أن تكون الكمية المعدودة سالبة",
      "wholeUnits": "هذا المنتج يُعدّ بوحدات كاملة",
      "costRequired": "أدخل تكلفة الوحدة للمخزون المضاف",
      "costFormat": "أدخل تكلفة تساوي 0 أو أكثر، بست منازل عشرية كحد أقصى",
      "chooseReason": "اختر سبب تغيّر المخزون",
      "notOnHand": "لا تتوفر هذه الكمية في هذا المستودع؛ لا يمكن أن تُنزل التسوية المخزون دون الصفر",
      "serialCount": "أدخل رقمًا تسلسليًا لكل وحدة: المطلوب {{needed}}، والمُدخل {{given}}",
      "serialCountDifference": "أدخل رقمًا تسلسليًا لكل وحدة من الفرق عن المخزون: المطلوب {{needed}}، والمُدخل {{given}}"
    },
    "errors": {
      "notPosted": "لم تُرحَّل التسوية",
      "service": "الخدمات لا تُخزَّن. اختر منتجًا من البضائع.",
      "alreadyVoid": "هذه التسوية مُبطَلة بالفعل."
    },
    "toast": {
      "posted": "رُحّلت التسوية {{number}}",
      "voided": "أُبطِلت التسوية {{number}}"
    },
    "title": "تسويات المخزون",
    "subtitle": "المخزون الافتتاحي والتسويات والجرد، مع قيمتها بالتكلفة.",
    "new": "تسوية جديدة",
    "views": "عروض التسويات",
    "view": {
      "all": "الكل",
      "opening": "افتتاحي",
      "adjustment": "التسويات",
      "count": "الجرد",
      "void": "الملغاة"
    },
    "searchPlaceholder": "ابحث بالرقم أو الملاحظات…",
    "searchLabel": "البحث في التسويات",
    "clearSearch": "مسح البحث",
    "reasonFilter": "السبب",
    "allReasons": "كل الأسباب",
    "warehouseFilter": "المستودع",
    "allWarehouses": "كل المستودعات",
    "emptyFiltered": "لا توجد تسويات مطابقة.",
    "clearFilters": "مسح عوامل التصفية",
    "empty": {
      "title": "لا توجد تسويات مخزون بعد.",
      "body": "سجّل مخزوناً افتتاحياً أو شطباً أو جرداً.",
      "view": {
        "opening": "لم يُسجَّل مخزون افتتاحي.",
        "adjustment": "لا توجد تسويات.",
        "count": "لا توجد عمليات جرد.",
        "void": "لا توجد تسويات ملغاة."
      }
    },
    "rowActions": "إجراءات {{number}}",
    "actions": {
      "open": "فتح"
    },
    "chooseReason": "اختر السبب",
    "countHint": "الكمية المتوفرة هي ما يسجله النظام في هذا المستودع الآن. عند الترحيل يُقارن الجرد بالكمية المتوفرة في نهاية تاريخ الجرد.",
    "onHandFailed": "غير متاح",
    "hints": {
      "reason": "سبب تغيّر المخزون: تُعرض التقارير وعوامل التصفية حسبه."
    },
    "reasonCode": {
      "DAMAGE": "تالف",
      "EXPIRED": "منتهي الصلاحية",
      "THEFT_LOSS": "سرقة أو فقدان",
      "FOUND": "عُثر عليه",
      "CORRECTION": "تصحيح",
      "OTHER": "أخرى"
    },
    "stats": {
      "label": "أرقام تسويات المخزون",
      "writeOffs": "المشطوب",
      "gains": "الزيادات",
      "monthDetail": "{{month}} · {{documents}}",
      "trend": "المخزون المشطوب حسب الشهر، من {{from}} إلى {{to}}",
      "counts": "الجرد",
      "countsDetail": "عمليات الجرد المرحّلة",
      "void": "الملغاة",
      "voidDetail": "ملغاة ومعكوسة",
      "documents_zero": "لا مستندات",
      "documents_one": "مستند واحد",
      "documents_two": "مستندان",
      "documents_few": "{{n}} مستندات",
      "documents_many": "{{n}} مستندًا",
      "documents_other": "{{n}} مستند"
    },
    "figures": "أرقام التسوية",
    "valueIn": "أُضيف إلى المخزون بالتكلفة",
    "valueOut": "خرج من المخزون بالتكلفة",
    "valueNone": "لا تغيير في القيمة",
    "increased": "زيادة",
    "decreased": "نقص",
    "linesCount_zero": "لا منتجات",
    "linesCount_one": "منتج واحد",
    "linesCount_two": "منتجان",
    "linesCount_few": "{{n}} منتجات",
    "linesCount_many": "{{n}} منتجًا",
    "linesCount_other": "{{n}} منتج",
    "openJournal": "فتح القيد اليومي",
    "journalPosted": "مرحّل إلى الدفاتر",
    "noJournal": "لا شيء للترحيل",
    "sectionHint": "أين المخزون، وفي أي يوم، ونوع التغيير."
  },
  "transfers": {
    "title": "تحويلات المخزون",
    "subtitle": "البضائع المنقولة من مستودع إلى آخر. لا تتغير قيمة المخزون.",
    "new": "تحويل جديد",
    "newTitle": "تحويل مخزون جديد",
    "newSubtitle": "يُحفظ كمسودة. الترحيل ينقل البضاعة ويُعيَّن الرقم عندها.",
    "prefillFailed": "تعذّر تحميل المنتج. اختره في السطر بدلًا من ذلك.",
    "editTitle": "تعديل {{title}}",
    "editSubtitle": "لا يمكن تعديل إلا المسودة.",
    "draftTitle": "مسودة تحويل",
    "saveDraft": "حفظ المسودة",
    "notDraftTitle": "لم يعد هذا التحويل مسودة",
    "backToTransfer": "العودة إلى التحويل",
    "voidTitle": "هذا التحويل مُبطَل",
    "draftNote": "المسودة لا تنقل أي مخزون. رحّلها عند إرسال البضاعة.",
    "searchLabel": "البحث في التحويلات",
    "searchPlaceholder": "ابحث بالرقم أو الملاحظات…",
    "clearSearch": "مسح البحث",
    "statusFilter": "تصفية حسب الحالة",
    "allStatuses": "كل الحالات",
    "warehouseFilter": "تصفية حسب المستودع",
    "allWarehouses": "كل المستودعات",
    "emptyFiltered": "لا شيء يطابق عوامل التصفية هذه.",
    "clearFilters": "مسح عوامل التصفية",
    "chooseWarehouse": "اختر مستودعًا",
    "chooseProduct": "اختر منتجًا",
    "addLine": "إضافة منتج",
    "removeLine": "حذف البند {{n}}",
    "lineActions": "إجراءات البند",
    "enterHint": "مفتاح Enter في آخر بند يضيف بندًا جديدًا.",
    "productOfLine": "المنتج في البند {{n}}",
    "quantityOfLine": "الكمية في البند {{n}}",
    "status": {
      "DRAFT": "مسودة",
      "POSTED": "مرحّل",
      "VOID": "مُبطَل"
    },
    "sections": {
      "transfer": "التحويل",
      "lines": "المنتجات",
      "route": "المسار"
    },
    "fields": {
      "number": "الرقم",
      "date": "تاريخ التحويل",
      "from": "من المستودع",
      "to": "إلى المستودع",
      "route": "من ← إلى",
      "lineCount": "المنتجات",
      "notes": "ملاحظات",
      "product": "المنتج",
      "quantity": "الكمية",
      "value": "القيمة بالتكلفة",
      "totalValue": "إجمالي القيمة المنقولة",
      "status": "الحالة",
      "updatedAt": "آخر تعديل",
      "createdBy": "أنشأه",
      "postedAt": "رُحّل"
    },
    "hints": {
      "lines": "بضائع فقط، وكل منتج مرة واحدة. يجب أن تتوفر الكمية في مستودع المصدر عند الترحيل.",
      "value": "تخرج البضاعة بمتوسط تكلفتها وتدخل بالقيمة نفسها تمامًا."
    },
    "lineErrors": {
      "chooseProduct": "اختر منتجًا",
      "wholeUnits": "هذا المنتج يُعدّ بوحدات كاملة",
      "service": "الخدمات لا تُخزَّن. اختر منتجًا من البضائع.",
      "duplicate": "هذا المنتج موجود في بند آخر",
      "sameWarehouse": "اختر مستودعًا مختلفًا للتحويل إليه",
      "serialCount": "أدخل رقمًا تسلسليًا لكل وحدة: المطلوب {{needed}}، والمُدخل {{given}}",
      "serialsOver": "الأرقام التسلسلية أكثر من الوحدات: {{given}} مقابل {{needed}}. احذف بعضها أو زِد الكمية."
    },
    "serialsMissingTitle": "أرقام تسلسلية ناقصة",
    "serialsMissing": "كل بند يتتبّع الأرقام التسلسلية يحتاج إلى رقم تسلسلي لكل وحدة قبل الترحيل. عدّل التحويل لإضافتها.",
    "errors": {
      "STOCK_TRANSFER_POSTED": "لا يمكن تعديل التحويل أو ترحيله أو حذفه إلا وهو مسودة. التحويل المرحّل يمكن إبطاله فقط.",
      "STOCK_TRANSFER_NOT_POSTED": "لا يمكن إبطال إلا التحويل المرحّل؛ احذف المسودة بدلًا من ذلك.",
      "STOCK_NOT_ON_HAND": "بعض هذه البضائع غير متوفر في مستودع المصدر، لذا لا يمكن تحويله.",
      "STOCK_ALREADY_USED": "استُخدم بعض البضائع التي أدخلها هذا التحويل. حوّلها مرة أخرى بدلًا من الإبطال.",
      "WAREHOUSE_ARCHIVED": "أحد المستودعين مؤرشف. اختر مستودعًا نشطًا."
    },
    "actions": {
      "post": "ترحيل التحويل",
      "delete": "حذف المسودة",
      "void": "إبطال التحويل",
      "open": "فتح",
      "edit": "تعديل المسودة",
      "print": "طباعة"
    },
    "post": {
      "title": "ترحيل هذا التحويل؟",
      "body": "تخرج البضاعة من {{from}} وتدخل إلى {{to}} بتاريخ {{date}} بمتوسط تكلفتها. لا تتغير قيمة المخزون."
    },
    "delete": {
      "title": "حذف هذه المسودة؟",
      "body": "تُحذف المسودة. لم يُنقل أي مخزون."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "تعود البضاعة إلى مستودع المصدر، بشرط أن تكون ما تزال متوفرة حيث وصلت. يبقى التحويل مسجلًا وعليه علامة الإبطال."
    },
    "toast": {
      "saved": "حُفظت مسودة التحويل",
      "posted": "رُحّل التحويل",
      "deleted": "حُذفت المسودة",
      "voided": "أُبطِل {{number}}"
    },
    "empty": {
      "title": "لا توجد تحويلات مخزون بعد.",
      "body": "انقل البضاعة من مستودع إلى آخر."
    },
    "loadingProduct": "جارٍ تحميل المنتج…",
    "rowActions": "إجراءات {{number}}",
    "print": {
      "title": "تحويل مخزون",
      "from": "من",
      "to": "إلى",
      "dispatchedBy": "سلّمه",
      "receivedBy": "استلمه",
      "product": "المنتج",
      "code": "رمز المنتج / الباركود",
      "quantity": "الكمية",
      "back": "العودة إلى التحويل",
      "voidBanner": "أُلغي في {{date}}: أُعيدت هذه البضاعة.",
      "signatures": "التواقيع",
      "nameAndDate": "الاسم والتوقيع والتاريخ",
      "fixedLine": "كميات فقط، بلا أسعار.",
      "lineCount_zero": "لا بنود",
      "lineCount_one": "بند واحد",
      "lineCount_two": "بندان",
      "lineCount_few": "{{count}} بنود",
      "lineCount_many": "{{count}} بنداً",
      "lineCount_other": "{{count}} بند"
    },
    "stats": {
      "label": "أرقام التحويلات",
      "drafts": "المسودات",
      "draftsDetail": "بانتظار الترحيل",
      "moved": "المنقول",
      "movedDetail": "{{month}} · {{transfers}}",
      "trend": "قيمة المنقول حسب الشهر، من {{from}} إلى {{to}}",
      "posted": "المرحّلة",
      "postedDetail": "بضائع منقولة",
      "void": "الملغاة",
      "voidDetail": "أُعيدت البضائع",
      "transfers_zero": "لا تحويلات",
      "transfers_one": "تحويل واحد",
      "transfers_two": "تحويلان",
      "transfers_few": "{{n}} تحويلات",
      "transfers_many": "{{n}} تحويلًا",
      "transfers_other": "{{n}} تحويل"
    },
    "productCount_zero": "لا منتجات",
    "productCount_one": "منتج واحد",
    "productCount_two": "منتجان",
    "productCount_few": "{{n}} منتجات",
    "productCount_many": "{{n}} منتجًا",
    "productCount_other": "{{n}} منتج",
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "sectionHint": "من أين تخرج البضاعة، وإلى أين تصل، وفي أي يوم."
  },
  "serialErrors": {
    "SERIAL_COUNT_MISMATCH": "أدخل رقمًا تسلسليًا لكل وحدة",
    "countMismatch": "أدخل رقمًا تسلسليًا لكل وحدة من الفرق بين الجرد والمخزون في تاريخ الجرد",
    "SERIAL_DUPLICATE": "مكرر، أو موجود في المخزون أو مبيع بالفعل: {{serials}}",
    "SERIAL_NOT_AVAILABLE": "غير متوفر في هذا المستودع: {{serials}}",
    "notReceivable": "لا يمكن استلامه هنا: {{serials}}",
    "SERIALS_NOT_TRACKED": "هذا المنتج لا يتتبّع الأرقام التسلسلية. احذفها.",
    "other": "راجع الأرقام التسلسلية في هذا البند"
  },
  "serials": {
    "mark": "ر.ت",
    "tally": "{{count}} / {{quantity}}",
    "tallyLabel": "الأرقام التسلسلية لـ{{product}}: {{count}} من {{quantity}}",
    "tallyLabelOpen": "الأرقام التسلسلية لـ{{product}}: {{count}}",
    "title": "الأرقام التسلسلية · {{product}}",
    "hint": {
      "new": "امسح الرقم التسلسلي لكل وحدة، أو اكتبه واضغط Enter. الصق قائمة لإضافة عدة أرقام دفعة واحدة.",
      "inStock": "امسح الرقم التسلسلي لكل وحدة خارجة، أو حدّده أدناه. تظهر فقط الأرقام المتوفرة في هذا المستودع.",
      "sold": "امسح أو حدّد الأرقام التسلسلية العائدة. تظهر فقط الأرقام المبيعة في بند الفاتورة هذا."
    },
    "scan": "الرقم التسلسلي",
    "scanPlaceholder": "امسح أو اكتب ثم اضغط Enter",
    "enteredHeading": "المُدخلة",
    "chosenHeading": "المحدَّدة",
    "chooseHeading": "الأرقام التسلسلية المتاحة للاختيار",
    "goneHeading": "لم تعد متاحة",
    "progress": "{{count}} من {{quantity}}",
    "entered_zero": "لا أرقام تسلسلية",
    "entered_one": "رقم تسلسلي واحد",
    "entered_two": "رقمان تسلسليان",
    "entered_few": "{{count}} أرقام تسلسلية",
    "entered_many": "{{count}} رقمًا تسلسليًا",
    "entered_other": "{{count}} رقم تسلسلي",
    "added": "أُضيف {{serial}}",
    "duplicate": "{{serial}} موجود في القائمة",
    "ticked": "حُدِّد {{serial}}",
    "alreadyTicked": "{{serial}} محدَّد بالفعل",
    "notInStock": "{{serial}} غير متوفر في هذا المستودع",
    "notSold": "{{serial}} لم يُبع في هذا البند، أو أُرجع بالفعل",
    "remove": "إزالة {{serial}}",
    "empty": {
      "new": "لا أرقام تسلسلية بعد. امسح الوحدة الأولى.",
      "inStock": "لا توجد أرقام تسلسلية لهذا المنتج في هذا المستودع.",
      "sold": "لم يبقَ ما يُرجع في هذا البند."
    },
    "gone": {
      "inStock": "لم يعد متوفرًا هنا",
      "sold": "لم يعد في هذا البند"
    },
    "noMatch": "لا يوجد رقم تسلسلي يطابق «{{q}}».",
    "quantityBecomes": "تصبح كمية البند {{count}}.",
    "cancel": "إلغاء",
    "use_zero": "استخدام الأرقام التسلسلية",
    "use_one": "استخدام رقم تسلسلي واحد",
    "use_two": "استخدام رقمين تسلسليين",
    "use_few": "استخدام {{count}} أرقام تسلسلية",
    "use_many": "استخدام {{count}} رقمًا تسلسليًا",
    "use_other": "استخدام {{count}} رقم تسلسلي",
    "clear": "مسح الأرقام التسلسلية",
    "chooseWarehouse": "اختر المستودع أولًا: تُختار الأرقام التسلسلية من مخزونه.",
    "more_zero": "+{{count}}",
    "more_one": "+{{count}} آخر",
    "more_two": "+{{count}} آخران",
    "more_few": "+{{count}} أخرى",
    "more_many": "+{{count}} أخرى",
    "more_other": "+{{count}} أخرى",
    "pageTitle": "الأرقام التسلسلية",
    "subtitle": "ابحث عن وحدة برقمها التسلسلي: أين هي، وكل مستند حرّكها.",
    "tabTitle": "الأرقام التسلسلية",
    "searchLabel": "البحث في الأرقام التسلسلية",
    "searchPlaceholder": "امسح أو اكتب رقمًا تسلسليًا…",
    "clearSearch": "مسح البحث",
    "statusFilter": "الحالة",
    "allStatuses": "كل الحالات",
    "warehouseFilter": "المستودع",
    "allWarehouses": "كل المستودعات",
    "emptyTitle": "لا أرقام تسلسلية بعد",
    "emptyBody": "تظهر عند استلام بضاعة منتج يتتبّع الأرقام التسلسلية.",
    "emptyFiltered": "لا يوجد رقم تسلسلي يطابق هذه الفلاتر.",
    "inWarehouse": "في {{warehouse}}",
    "historyTitle": "السجل",
    "status": {
      "IN_STOCK": "في المخزون",
      "SOLD": "مُباع",
      "RETURNED_TO_SUPPLIER": "مُرجَع للمورد",
      "REMOVED": "مُزال",
      "ISSUED_TO_PROJECT": "مصروف إلى مشروع"
    },
    "reason": {
      "OPENING": "رصيد افتتاحي",
      "PURCHASE": "استُلم في مشتريات",
      "PURCHASE_RETURN": "أُرجع إلى المورد",
      "SALE": "بِيع",
      "SALE_RETURN": "أرجعه العميل",
      "TRANSFER": "حُوِّل",
      "ADJUSTMENT": "تسوية مخزون",
      "PROJECT_ISSUE": "صُرف إلى مشروع",
      "PROJECT_RETURN": "أُرجع من مشروع"
    },
    "fields": {
      "serial": "الرقم التسلسلي",
      "product": "المنتج",
      "status": "الحالة",
      "warehouse": "المستودع",
      "receivedBy": "استُلم بموجب",
      "issuedBy": "صُرف بموجب",
      "updatedAt": "آخر حركة"
    },
    "history": {
      "date": "التاريخ",
      "what": "ما حدث",
      "status": "الحالة بعدها",
      "warehouse": "المستودع",
      "document": "المستند",
      "by": "بواسطة",
      "system": "النظام",
      "reversal": "إبطال",
      "empty": "لا حركات مسجّلة."
    },
    "useNone": "استخدام الأرقام التسلسلية",
    "legacyImport": "من CloudTech، قبل الانتقال",
    "whereTitle": "مكانه الآن"
  }
}
